"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchKatalServerProvider = exports.KatalServerProvider = void 0;
const art_metrics_1 = require("@amzn/art-metrics");
const KatalMetrics = __importStar(require("@amzn/katal-metrics"));
const isomorphic_1 = require("../../../isomorphic");
class KatalServerProvider {
    constructor({ site, serviceName, domain = 'prod', realm = 'USAmazon', errorHandler }) {
        const metricsPromise = new Promise((resolve) => {
            if (process.browser) {
                if (errorHandler) {
                    this.metricsErrorHandler = errorHandler;
                }
                Promise.resolve().then(() => __importStar(require('@amzn/katal-metrics-driver-sushi'))).then((module) => {
                    const KatalMetricsDriverSushi = module.default;
                    const metricsDriver = new KatalMetricsDriverSushi.Builder()
                        .withDomainRealm(domain, realm)
                        .withErrorHandler(this.metricsErrorHandler)
                        .build();
                    const metricsContext = new KatalMetrics.Context.Builder()
                        .withSite(site)
                        .withServiceName(serviceName)
                        .build();
                    const metricsPublisher = new KatalMetrics.Publisher(metricsDriver, this.metricsErrorHandler, metricsContext);
                    resolve(metricsPublisher);
                })
                    .catch(() => {
                    isomorphic_1.LOGGER.error('Failed importing sushi driver for metrics');
                    resolve(undefined);
                });
            }
            else {
                resolve(undefined);
            }
        });
        this.metric = metricsPromise;
    }
    record(eventObject) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const metric = yield this.metric;
                if (process.browser && metric) {
                    const childActionPublisher = metric.newChildActionPublisherForMethod(eventObject.name);
                    switch (eventObject.type) {
                        case art_metrics_1.MetricType.COUNTER:
                            childActionPublisher.publishCounterMonitor(eventObject.eventName, eventObject.value);
                            break;
                        case art_metrics_1.MetricType.TIMER:
                            childActionPublisher.publishTimerMonitor(eventObject.eventName, eventObject.value);
                            break;
                        default:
                            throw new Error(`Type: ${eventObject.type} is not supported by Katal`);
                    }
                }
            }
            catch (err) {
                isomorphic_1.LOGGER.error('Error logging metrics', err);
            }
        });
    }
    recordOnServer(eventObject) {
        return __awaiter(this, void 0, void 0, function* () {
            this.record(eventObject);
        });
    }
    metricsErrorHandler(err) {
        isomorphic_1.LOGGER.error('Metrics Error:', err);
    }
}
exports.KatalServerProvider = KatalServerProvider;
const fetchKatalServerProvider = (config) => __awaiter(void 0, void 0, void 0, function* () {
    return new KatalServerProvider(config);
});
exports.fetchKatalServerProvider = fetchKatalServerProvider;
